import { StandardChip } from "../../../../../shared/components/badges/StandardChip"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import { isOverCapacity } from "../meetingRoomsLib"
import type { MeetingRoomBooking, MeetingRoomRow } from "../meetingRoomsTypes"

type MeetingRoomBookingTagsProps = Readonly<{
    booking: MeetingRoomBooking
    room: MeetingRoomRow
}>

export function MeetingRoomBookingTags({ booking, room }: MeetingRoomBookingTagsProps) {
    return (
        <>
            {booking.tableSetupName && (
                <StandardChip placement="table" size="small" variant="info">
                    {booking.tableSetupName}
                </StandardChip>
            )}
            {booking.hasCatering && (
                <StandardChip placement="table" size="small" variant="yellow">
                    <LocalizedStrict id="service-center-meeting-rooms-booking-catering-chip">
                        <span>Catering</span>
                    </LocalizedStrict>
                </StandardChip>
            )}
            {isOverCapacity(booking, room) && (
                <StandardChip placement="table" size="small" variant="red">
                    <LocalizedStrict id="service-center-meeting-rooms-booking-over-capacity-chip">
                        <span>Over capacity</span>
                    </LocalizedStrict>
                </StandardChip>
            )}
        </>
    )
}
